module.exports = __webpack_public_path__ + "img/produktfilter.767075d5.svg";